const FAILED_PENDING_MESSAGE_ERROR_KEY =
  "__terraMatrixFailedPendingMessageCreated";

type FailedPendingMessageError = Error & {
  [FAILED_PENDING_MESSAGE_ERROR_KEY]: true;
};

export const markFailedPendingMessageError = (error: Error): Error => {
  Object.defineProperty(error, FAILED_PENDING_MESSAGE_ERROR_KEY, {
    configurable: true,
    value: true,
  });

  return error;
};

export const isFailedPendingMessageError = (
  error: unknown,
): error is FailedPendingMessageError =>
  error instanceof Error &&
  Reflect.get(error, FAILED_PENDING_MESSAGE_ERROR_KEY) === true;
